import { supabase } from "@/integrations/supabase/client";

/**
 * Records activity for today and returns the resulting consecutive-day streak
 * (null when the update failed).
 */
export async function updateStreak(userId: string): Promise<number | null> {
  const { data, error } = await (supabase.rpc as any)("update_streak", { p_user_id: userId });
  if (error) {
    console.error("Failed to update streak:", error);
    return null;
  }
  const streak = (data as { streak?: number } | null)?.streak;
  return typeof streak === "number" ? streak : null;
}
